import _ from 'lodash';
import { createSelector } from 'reselect';

const FINGERPRINT_GENERATE_SUCCESS = 'cybersource/FINGERPRINT_GENERATE_SUCCESS';
const FINGERPRINT_DELETED = 'cybersource/FINGERPRINT_DELETED';

export const fingerPrintGenerated = payload => ({
  type: FINGERPRINT_GENERATE_SUCCESS,
  payload,
});

export const deleteFingerprint = () => ({
  type: FINGERPRINT_DELETED,
});

const initialState = {
  fingerprint: null,
};

const cyberSoruceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FINGERPRINT_GENERATE_SUCCESS:
      return { ...state, fingerprint: action.payload };

    case FINGERPRINT_DELETED:
      return { ...state, fingerprint: null };

    default:
      return state;
  }
};

export default cyberSoruceReducer;

export const getCyberSourceState = state =>
  _.get(state, ['payments', 'cybersource']);

export const getFingerprint = createSelector(
  [getCyberSourceState],
  cyberSource => _.get(cyberSource, 'fingerprint'),
);
